import styled from 'styled-components';

export const Container = styled.div`
  height: calc(100vh - 60px);
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;

  &::before {
    content: '';
    position: fixed;
    top: 60px;
    left: 0;
    width: 280px;
    height: calc(100vh - 60px);
    background-image: 
      radial-gradient(circle at 20% 80%, rgba(244, 241, 222, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(244, 241, 222, 0.08) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
    transition: width 0.3s, left 0.3s;

    @media (max-width: 768px) {
      width: 280px;
    }
  }

  &::after {
    content: '';
    position: fixed;
    top: 60px;
    left: 0;
    width: 280px;
    height: calc(100vh - 60px);
    background-image: 
      repeating-linear-gradient(
        45deg,
        transparent,
        transparent 4px,
        rgba(244, 241, 222, 0.02) 4px,
        rgba(244, 241, 222, 0.02) 6px
      );
    pointer-events: none;
    z-index: 0;
    transition: width 0.3s, left 0.3s;

    @media (max-width: 768px) {
      width: 280px;
    }
  }

  &.collapsed {
    &::before,
    &::after {
      width: 50px;
    }

    @media (max-width: 768px) {
      &::before,
      &::after {
        left: -280px;
        width: 280px;
      }
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: auto;
  }

  @media (max-width: 470px) {
    width: 100%;
    min-width: auto;
    padding-bottom: 100px;
  }

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: linear-gradient(180deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(244, 241, 222, 0.3);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(244, 241, 222, 0.5);
  }
`;

export const LogoOrgBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px 15px 0 15px;
  padding: 15px 10px;
  position: relative;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${(props) => (props.isCollapsed ? 'transparent' : 'rgba(244, 241, 222, 0.05)')};
    border-radius: 12px;
    backdrop-filter: ${(props) => (props.isCollapsed ? 'none' : 'blur(10px)')};
  }

  img {
    width: ${(props) => (props.isCollapsed ? '40px' : '79px')};
    transition: all 0.3s ease;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
    position: relative;
    z-index: 2;
  }

  @media (max-width: 768px) {
    margin: 15px 10px;
    padding: 12px 8px;
  }

  @media (max-width: 470px) {
    margin: 10px 8px;
    padding: 10px 6px;
  }
`;
